var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryTruck2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20.233,
    viewBox: "0 0 30 20.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delivery-truck_1_",
    "data-name": "delivery-truck (1)",
    transform: "translate(0 -67.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1891",
    "data-name": "Group 1891",
    transform: "translate(0 67.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1890",
    "data-name": "Group 1890",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M0,233.957a.522.522,0,0,0,.523.549h.835a3.7,3.7,0,0,1,3.322-2.175A3.7,3.7,0,0,1,8,234.506H18.859v-4.442H0Z",
    transform: "translate(0 -218.195)",
    fill: "#1b62ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M32.934,277.32a2.462,2.462,0,1,0,2.462,2.462A2.462,2.462,0,0,0,32.934,277.32Z",
    transform: "translate(-28.253 -262.01)",
    fill: "#1b62ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M284.655,192.095l-2.345-1.031H275v7.281h1.419a3.625,3.625,0,0,1,6.645,0h1.389a.522.522,0,0,0,.523-.549v-5.172A.566.566,0,0,0,284.655,192.095Z",
    transform: "translate(-254.976 -182.035)",
    fill: "#1b62ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M279.9,121.96a1.672,1.672,0,0,0-1.509-.9H275v3.932h6.474Z",
    transform: "translate(-254.976 -117.129)",
    fill: "#1b62ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M17.187,67.064H1.663A1.678,1.678,0,0,0,0,68.771v9H18.859v-9s0-.005,0-.008A1.686,1.686,0,0,0,17.187,67.064Z",
    transform: "translate(0 -67.064)",
    fill: "#1b62ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M308.767,277.32a2.462,2.462,0,1,0,2.462,2.462h0A2.462,2.462,0,0,0,308.767,277.32Z",
    transform: "translate(-284.001 -262.01)",
    fill: "#1b62ab"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck2);
export default __webpack_public_path__ + "static/media/delivery-truck-2.6fedd0be.svg";
export { ForwardRef as ReactComponent };